<template>
  <div class="ApplicationWelcome">
    
    <h3>Emergency Assistance Application</h3>
    
    <b-container class="content">
      <b-row class="WelcomeCopy">
        <b-col>
          <h2>Before you start, please read the following:</h2>
          <h2><b><u>Note:</u></b> Your application will <b>NOT</b> be processed if you have not called our main line at <b>612-615-9034</b> and already been contacted by a Building Blocks caseworker</h2>
        </b-col>
      </b-row>

      <b-row>
        <b-col lg="3">
          <div class="intro">
            <img class="intro-icon" alt="What will I need?" src="@/assets/icon-whats-online.png" />
          </div>

          <div class="intro-desc">
            <h2>What can I get help with?</h2>
            <ul>
              <li>We are an emergency assistance program funded by the community (Sadaqah and Zakat),  to support you during times of need, or financial emergency.</li>
              <li>We help with bills such as rent, mortgage, utilities, car payments, etc. that you are past due on.</li>
              <li>We do NOT help people who are outside the state of Minnesota, and we do not help with loans or tuition.</li>
            </ul>
          </div>
        </b-col>

        <b-col lg="3">
          <div class="intro">
            <img
              class="intro-icon"
              alt="What will I need?"
              src="@/assets/icon-temporary-residents.svg"
            />
          </div>

          <div class="intro-desc">
            <h2>How much can I get help with?</h2>
            <p>
              Based on our current budget, the average approval amount for Emergency Assistance cases is between $300 - $400 (higher amounts may be approved if funds allow). If you are still interested in applying with us, please register or log in below and fill out the application form.
            </p>
          </div>
        </b-col>

        <b-col lg="3">
          <div class="intro">
            <img
              class="intro-icon"
              alt="What will I need?"
              src="@/assets/icon-temporary-residents.svg"
            />
          </div>

          <div class="intro-desc">
            <h2>Do you need assistance due to language, disability, or any other barriers?</h2>
            <ul>
              <li>You may ask someone who you trust to fill out the application, on your behalf.</li>
              <li>You may call us at 612-615-9034 and leave a detailed voice message.</li>
            </ul>
          </div>
        </b-col>

        <b-col lg="3">
          <div class="intro">
            <img class="intro-icon" alt="What will I need?" src="@/assets/icon-complete-app.svg" />
          </div>

          <div class="intro-desc">
            <h2>What will I need to complete this application?</h2>
            <ul>
              <li>Personal Information</li>
              <li>Household Information</li>
              <li>Documentation/Proofs of Income and the Services Needed</li>
              <li>Contact information for two references</li>
            </ul>
          </div>
        </b-col>
      </b-row>

      <b-row>
        <b-col>
          <hr />
        </b-col>
      </b-row>

      <b-row>
        <b-col>
          <ul class="horizontal-list">            
            <li class="what-happens">
              <h2>What happens once I apply?</h2>
              <p>After completing the online application part of the process, you will hear back from us within 2 to 3 business days regarding the status of your application.</p>
            </li>
          </ul>
        </b-col>
      </b-row>

      <b-row class="search-address-row white-card">
        <b-col>
          <h2>Are you ready to start your application?</h2>
          <p>
            Completing this application usually takes 15-20 minutes. This application will be saved for you to return later.
          </p> 
          <b-form >
   
          <b-row>
      
          <b-col sm="12" lg="3" class="pb-3 pt-3">
          <b-button          
          class="btn-search"
          type="button"
          variant="primary"
          @click="onClick"
          >   
          Start Application</b-button
        >
      </b-col>
    </b-row>
  </b-form>         
        </b-col>
      </b-row>
    </b-container>

  </div>
  
</template>

<script>
import ApplicationBanner from '@/components/application/ApplicationBanner.vue'

export default {
  name: 'ApplicationWelcome',
  components: {    
    ApplicationBanner
  },  
  computed: {    
  },
  created() {    
  },
  methods: {
  onClick() {
      
        this.nextStep()
      
    },
    nextStep() {
      this.$store.dispatch('setInitialVitalData', {
        serviceName: 'Emergency Assistance'        
      })
      this.$store.dispatch('set', ['isNewApplication', true])
      this.$scrollTo('#app', 1)
      this.$router.history.push('/pilot')
    }
  }
}
</script>

<style lang="scss" scoped>
$sideBarWidth: 200px;

.ApplicationWelcome {
  padding: 0 0 30px;
  .content.container {
    padding: 94px 15px 0;
    .WelcomeCopy {
      h2 {
        line-height: 28px;
      }
    }
    .search-address-row {
      position: relative;

      form {
        padding: 6px 0 0;
      }

      h2 {
        padding: 0 0 5px;
        font-size: 21px;
      }
    }

    .intro {
      text-align: center;
      padding: 15px 30px 5px;
    }

    .intro-desc {
      h2 {
        padding-bottom: 0;
        margin-bottom: 10px;
        padding-right: 20px;
      }
    }
  }

  ul {
    padding: 0 0px 0 15px;
    font-size: $text;

    &.horizontal-list {
      padding: 40px 0 5px 5px;
      list-style: none;

      li {
        position: relative;
        padding: 0 0 35px 120px;
        line-height: 26px;
        p {
          line-height: 26px;
        }
        &:before {
          content: '';
          position: absolute;
          top: 0;
          left: 0;
          display: block;
          width: 91px;
          height: 91px;
        }
      }

      h2 {
        padding: 0 15px 5px 0;
      }
    }
  }

  h1 {
    &.invalid-code-msg {
      padding: 30px 0;
    }
  }

  h2 {
    line-height: 28px;
    padding: 2rem 0;
  }

  .container {
    text-align: left;

    hr {
      margin: 2rem 0 0;
    }

    .intro-icon {
      height: auto;
    }

    .slide-fade-enter-active {
      transition: all 0.3s ease;
    }

    .slide-fade-leave-active {
      transition: all 0.3s cubic-bezier(1, 0.5, 0.8, 1);
    }

    .slide-fade-enter,
    .slide-fade-leave-to {
      opacity: 0;
    }
  }

  .Note {
    padding: 40px 20px 20px;
  }
}

.btn-search {
  width: 100%;
  margin: 0;
  height: 5.6rem;
  padding: 0.9rem 1rem;
  &:disabled {
    border-color: $color-text-light;
    background-color: $color-text-light;
    cursor: not-allowed;
  }
}

@include desktop {
  .ApplicationWelcome {
    .ApplicationBanner {
      height: 218px;
    }
    .container {
      .intro-desc {
        padding: 0 25px;
      }

      .intro-icon {
        max-width: 180px;
      }
    }

    .Banner {
      h1 {
        font-size: 51px;
        line-height: 50px;
      }

      h3 {
        font-size: 26px;
        padding-top: 8px;
      }
    }
  }
}

@include tablet-wide {
  .ApplicationWelcome {
    .ApplicationBanner {
      height: 218px;
    }
    .container {
      .intro-icon {
        max-width: 170px;
      }
    }
  }
}

@include tablet {
  .ApplicationWelcome {
    .ApplicationBanner {
      height: 122px;
      max-height: 122px;
    }
    .content {
      margin-bottom: 20px;
      padding: 1.2rem 1.2rem 2rem;

      .search-address-row.white-card {
        h2,
        p {
          text-align: center;
        }
      }

      .intro-icon {
        max-width: 50%;
      }
    }
  }
}

@include mobile {
  .ApplicationWelcome {
    .content {
      &.container {
        margin-bottom: 20px;
        .WelcomeCopy {
          h2 {
            padding: 2rem 4rem;
            text-align: center;
          }
        }

        .intro-icon {
          min-width: 140px;
          width: 140px;
        }

        .intro-desc {
          padding: 0 20px;

          h2 {
            padding: 2rem 2rem;
            text-align: center;
          }

          p {
            text-align: center;
          }
        }

        .horizontal-list {
          li {
            padding: 120px 20px 35px;
            text-align: center;

            &::before {
              left: 50%;
              transform: translate(-50%, 0);
            }
          }
        }

        .search-address-row {
          h2,
          p {
            text-align: center;
          }
        }
      }
    }

    .Note {
      padding: 0 20px 20px !important;
    }
  }
}
</style>
